import { render } from "./EgresosDetalle.vue?vue&type=template&id=4d7f94a3&scoped=true"
import script from "./EgresosDetalle.vue?vue&type=script&lang=js"
export * from "./EgresosDetalle.vue?vue&type=script&lang=js"

import "./EgresosDetalle.vue?vue&type=style&index=0&id=4d7f94a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7f94a3"]])

export default __exports__